module.exports = __webpack_public_path__ + "img/lageplan_960.a564eabe.jpg";